
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import RunnitDynamicField from '@/views/Runnits/RunnitSettings/RunnitDynamicField.vue';
import ConfirmDialog from '@/components/base/ConfirmDialog.vue';
import { FieldDefUuid, RunnitNodeField } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'AdvancedForm',
	props: {
		advancedFields: {
			type: Array as PropType<RunnitNodeField[]>,
			required: true,
		},
		inputValues: {
			type: Object as PropType<Record<FieldDefUuid, any>>,
			required: true,
		},
		nodeId: {
			type: String,
			required: true,
		},
		disabled: { type: Boolean, default: false },
	},
	data () {
		return {
			showResetConfirmation: false,
		};
	},
	computed: {
		...mapState([
			'team',
			'runnitState',
			'loadingTeam',
			'loadingUser',
		]),
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		async confirmReset (closeDialog: Function) {
			this.$emit('reset-form');
			closeDialog();
		},
		onFieldInput ({ field, value }: { field: RunnitNodeField, value: any }) {
			this.$emit('input', { field, value });
		},
		onPromptLoadingChanged (isLoading: boolean) {
			this.$emit('loading-changed', isLoading);
		},
	},
	components: {
		RunnitDynamicField,
		ConfirmDialog,
	},
});
